import { Role } from './interfaces/User.types';

export const UNASSIGNABLE_ROLES = [Role.CustomerOperator];
